module.exports = __webpack_public_path__ + "static/media/Group 1890.e4d6a335.png";